import { localizedRoute } from 'Pods/Shared/paths'
import getListingBasePath from 'Pods/Shared/Utils/getListingBasePath'
import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

const lastSegment = (route) => route.split('/').filter(Boolean).pop()

export const getModelsBasePath = (locale) => lastSegment(localizedRoute({ key: 'models', locale }))

export const getPrintBasePath = (locale) => lastSegment(localizedRoute({ key: 'print-models', locale }))

export const getFreeModelsBasePath = (locale) => lastSegment(localizedRoute({ key: 'free-models', locale }))

export const getFreePrintBasePath = (locale) => lastSegment(localizedRoute({ key: 'free-print-models', locale }))

// The free listings (/free-3d-models, /free-3d-print-models) are their own localized routes whose
// print_ready route default the controller re-applies on every fetch, so the asset type has to
// swap between the two free segments exactly like between the paid ones.
export const isPrintBasePath = (basePath, locale) => (
  [getPrintBasePath(locale), getFreePrintBasePath(locale)].includes(basePath)
)

// The print scope lives in the path (/3d-print-models/..., /free-3d-print-models), not the query,
// so it must be read from the current location whenever the store is rebuilt from a URL. Client-only,
// like getListingBasePath: the SSR render receives the scope in the echoed params instead.
export const isPrintListingLocation = () => isPrintBasePath(getListingBasePath(), getLocaleParam() || 'en')
